import { render, staticRenderFns } from "./TeachingAssistantInfo.vue?vue&type=template&id=3acd7818&scoped=true"
import script from "./TeachingAssistantInfo.vue?vue&type=script&lang=js"
export * from "./TeachingAssistantInfo.vue?vue&type=script&lang=js"
import style0 from "./TeachingAssistantInfo.vue?vue&type=style&index=0&id=3acd7818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd7818",
  null
  
)

export default component.exports